import { Box, Typography } from '@mui/material';
import ExoAvatar from '../../ExoAvatar';
import CategoryIcon from '@mui/icons-material/Category';
import { useTranslation } from 'react-i18next';
import { BoilingDiv } from './BoilingDiv';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';

export const SalesObjectMatch = ({ match }) => {
  const { t } = useTranslation();

  const { element, score } = match;
  const { title, image, nr } = element || {};

  function getHeatMapColor(percentage) {
    // Clamp and normalize
    const pct = Math.max(0, Math.min(100, percentage)) / 100;

    const maxColor = 180; // softer than 255
    const baseLight = 60; // adds lightness to all channels

    const r = Math.round(baseLight + maxColor * pct);
    const g = baseLight; // stays constant, keeping it neutral
    const b = Math.round(baseLight + maxColor * (1 - pct));

    const toHex = (n) => n.toString(16).padStart(2, '0');
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
  }
  return (
    <Box className="flex items-center gap-2 w-full">
      {image ? (
        <img
          src={image?.temporaryUrl}
          className=" h-[40px] w-[60px] object-cover rounded-md"
        />
      ) : (
        <ExoAvatar
          picture={image?.temporaryUrl}
          type={image ? 'company' : 'contact'}
          icon={<CategoryIcon sx={{ fontSize: '30px' }} />}
          size="40px"
        />
      )}
      <Box className="flex justify-between items-center w-full">
        <Box>
          <Typography fontWeight={600}>{title}</Typography>
          <Typography className="opacity-50">{nr}</Typography>
        </Box>
        {match.score !== null && (
          <Box className="flex flex-row-reverse gap-2 lg:flex-col">
            <Typography
              variant="h4"
              textAlign="right"
              fontWeight={600}
              sx={{ color: getHeatMapColor(match.score) }}
              className="flex items-center gap-2"
            >
              <BoilingDiv heat={match.score}>
                <LocalFireDepartmentIcon
                  sx={{
                    color: getHeatMapColor(match.score),
                    transform: `scale(${(match.score + 100) / 170})`,
                    opacity: match.score < 20 ? 0 : 1,
                  }}
                />
              </BoilingDiv>
              {match.score}%
            </Typography>
            <Typography textAlign="right" className="opacity-50">
              {t('matching')}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};
